import { MIP_MANAGE_ROUTES } from '@dealstack/frontend/app/pages/Routing/routes';
import { mipManagePath } from '@dealstack/frontend/app/pages/Routing/routes.utils';
import { useBreadcrumbs } from '@dealstack/frontend/shared/components/Breadcrumbs/useBreadcrumbs';
import { useTranslationMipMessages } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { SummaryDealMip } from '@dealstack/shared/lib/generated';
import { useMemo } from 'react';
import { AddBreadcrumbItem } from '@dealstack/frontend/shared/components/Breadcrumbs/useBreadcrumbs.types';

type UseMessagesBreadcrumbsArgs = { view: 'home'; dealId?: string; currentMip?: SummaryDealMip };

export const generateMessagesBreadcrumbs = (
	props: UseMessagesBreadcrumbsArgs,
	tMipMessages: ReturnType<typeof useTranslationMipMessages>
): AddBreadcrumbItem[] => {
	if (!props.dealId) {
		return [];
	}

	switch (props.view) {
		case 'home': {
			const suffixBreadcrumb = {
				name: tMipMessages('breadcrumb.header'),
				url: '#',
			};

			if (props.currentMip) {
				const mipUrl = mipManagePath(MIP_MANAGE_ROUTES.INVESTORS, {
					mipId: props.currentMip.id ?? '',
					dealId: props.dealId ?? '',
				});

				const mipBreadcrumb = {
					name: props.currentMip.programmeName,
					url: `${mipUrl}`,
				};
				return [mipBreadcrumb, suffixBreadcrumb];
			}
			// return consistent structure with empty breadcrumbs when no MIP
			return [
				{
					name: '',
					url: '',
				},
				{
					name: '',
					url: '',
				},
			];
		}

		default:
			return [];
	}
};

export function useMessagesBreadcrumbs(props: UseMessagesBreadcrumbsArgs) {
	const tMipMessages = useTranslationMipMessages();

	const breadcrumbs = useMemo(() => {
		return generateMessagesBreadcrumbs(props, tMipMessages);
	}, [props, tMipMessages]);

	useBreadcrumbs(breadcrumbs);
}
